<template>
  <div
    ref="productListElemContainer"
    style="position: relative; width: 100%;"
    :style="{ height: computedMaxHeight }"
  >
    <select-size
      v-if="showSelectSize"
      :product="selectedItem"
      :menuOffset="menuOffset"
      @onClose="closeSelectSize"
      @onConfirm="confirmSelectSize"
    />
    <select-extra
      v-if="showProductExtra"
      :product="selectedItem"
      @onClose="closeProductExtra"
      @onConfirm="confirmProductExtra"
    />
    <ingredient-wizard
      v-if="showIngredientWizard"
      :isEditIngredientLayer="isEditIngredientLayer"
      :product="selectedItem"
      @onClose="closeIngredientWizard"
      @onConfirm="confirmIngredients"
    >
    </ingredient-wizard>
    <div
      class="gradient top"
      v-if="overflown"
      :style="{ opacity: gradient_top_opacity }"
    ></div>
    <div
      class="gradient bottom"
      v-if="overflown"
      :style="{ opacity: gradient_bottom_opacity }"
    ></div>
    <div
      class="productList"
      :class="{
        noprices: noprices,
        'productList-isV2EditOrder': isEdit && isV2EditOrder
      }"
      ref="productListElem"
      :style="{
        'min-height': minHeight,
        'max-height': computedMaxHeight
      }"
    >
      <ItemList
        :itemsToShow="products_to_show"
        :delay="delay"
        :big="big"
        :bigItem="bigItem"
        :menuOffset="menuOffset"
        :activeItem="activeItem"
        :activeCombo="activeCombo"
        @onItemClicked="prepareItem"
        @onConfirmProductAttributes="confirmProductAttributes"
      ></ItemList>
    </div>
  </div>
</template>
<script>
import { getTranslation, shuffleArray } from "@/utils/helpers";
import { toCalculatable, toPrintable } from "@/utils/pricing";
import {
  activeExtras,
  createNewObject,
  getPopulatedIngredientGroups,
  getProductExtrasByDeliveryMethod,
  productToBasketItem,
  sortExtras
} from "@/utils/products";
import { mapGetters } from "vuex";
import SelectSize from "../modals/selectSize";
import SelectExtra from "../modals/selectExtra";
import IngredientWizard from "../modals/ingredientWizard";
import ItemList from "@/components/common/ItemList.vue";
import { smoothScroll } from "@/utils/smoothScrool";
import { ProductListController } from "@/utils/ProductListController";
import { isV2EditOrder } from "@/utils/templateSettings";
import { isEmpty } from "lodash";

//update created() when new consts are introduced!!

//used in menu page
const GENERAL_LIST_HEIGHT = 1050;
//used in wizards, orderlist, editpage,...
const REDUCED_LIST_HEIGHT = 830;

export default {
  components: {
    ItemList,
    IngredientWizard,
    SelectExtra,
    SelectSize
  },
  computed: {
    products_to_show() {
      let products = this.itemIds
        ? this.itemIds.map(id => this.itemsDict[id])
        : [...this.products];

      products = products.filter(item => !item.hide);

      if (this.random) {
        products = shuffleArray(products);
      }

      if (this.noSoldout) {
        products = products.filter(item => !item.soldout);
      }

      if (this.limit !== -1) {
        products = products.slice(0, this.limit);
      }

      products.every((product, index) => {
        if (
          index % 3 === 2 &&
          product.id === this.currentCategory.highlight_product
        ) {
          let tmp = products[index - 1];
          products[index - 1] = product;
          products[index] = tmp;
          return false;
        } else return true;
      });

      return products;
    },
    computedMaxHeight() {
      if (this.maxHeight !== -1) {
        return this.maxHeight + "px";
      }
      if (this.big) {
        // prop 'big' is only used on menu page
        return GENERAL_LIST_HEIGHT + "px";
      }
      return REDUCED_LIST_HEIGHT + "px";
    },
    computedHeight() {
      return this.listState.rowCount * this.boxHeight + "px";
    },
    minHeight() {
      if (
        this.big &&
        this.currentCategory &&
        this.currentCategory.highlight_product
      ) {
        // prop 'big' indicates menu page
        return GENERAL_LIST_HEIGHT + "px";
      }
      return this.boxHeight + "px";
    },
    ...mapGetters({
      basket: "BASKET",
      selectedDeliveryMethod: "SELECTED_DELIVERY_METHOD",
      schedules: "SCHEDULES",
      currentCategory: "CURRENT_CATEGORY",
      itemsDict: "ITEMS_DICT"
    })
  },
  data() {
    return {
      isEditIngredientLayer: false,
      showSelectSize: false,
      showProductExtra: false,
      showIngredientWizard: false,
      selectedItem: {},
      overflown: false,
      gradient_top_opacity: 1.0,
      gradient_bottom_opacity: 1.0,
      positions_by_index: [],
      delay: [],
      listState: {
        rowCount: 0,
        rowsVisible: 5
      }
    };
  },
  props: {
    isEdit: Boolean,
    activeCombo: Object,
    activeItem: Object,
    products: Array,
    itemIds: Array,
    big: Boolean,
    maxHeight: {
      type: Number,
      default: -1
    },
    bigItem: Boolean,
    random: Boolean,
    noprices: Boolean,
    noSoldout: Boolean,
    menuOffset: Boolean,
    limit: {
      default: -1,
      type: Number
    },
    passive: Boolean,
    showInfoIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isV2EditOrder,
    showSelectMenuModal(item, animate) {
      console.log("ProductList - showSelectMenuModal");
      const params = {
        menu: item,
        animate: animate
      };
      this.$selectMenuModal.show(params);
    },
    getProductListController() {
      return new ProductListController(
        this.products_to_show,
        this.currentCategory,
        this.bigItem,
        this.maxHeight,
        this.$refs.productListElemContainer
      );
    },
    toCalculatable,
    toPrintable,
    getTranslation,
    confirmProductAttributes(item) {
      this.$emit("onConfirmProductAttributes");
      this.selectedItem = item;
      this.prepareItem(this.selectedItem);
    },
    closeSelectSize() {
      this.selectedItem = {};
      this.showSelectSize = false;
      this.showProductExtra = false;
    },
    confirmSelectSize(size) {
      const product = {
        ...createNewObject(this.selectedItem),
        selectedSize: createNewObject(size)
      };
      this.showSelectSize = false;
      this.prepareItem(product);
    },
    closeProductExtra() {
      this.selectedItem = {};
      this.showProductExtra = false;
    },
    confirmProductExtra(extras) {
      const product = {
        ...createNewObject(this.selectedItem),
        selectedExtras: extras
      };
      this.prepareItem(product);
      this.showProductExtra = false;
    },
    closeIngredientWizard() {
      this.selectedItem = {};
      this.showIngredientWizard = false;
      this.$emit("onCloseIngredientWizard");
    },
    confirmIngredients(ingredients) {
      const product = {
        ...createNewObject(this.selectedItem),
        ingredientWizardDone: true,
        ingredients: ingredients
      };
      this.prepareItem(product);
      this.showIngredientWizard = false;
      this.$emit("onConfirmIngredientWizard");
    },
    preselectSingleExtras(item) {
      let selectedExtras = [];
      let result_item = {
        ...createNewObject(item)
      };
      if (
        item.extras &&
        item.extras.length >= 1 &&
        (typeof item.selectedExtras === "undefined" ||
          item.selectedExtras.length !== item.extras.length)
      ) {
        item.extras.forEach(extraGroup => {
          let extrasByDeliveryMethod = activeExtras(
            extraGroup.extras,
            this.selectedDeliveryMethod
          ).filter(extra => !extra.hide);
          if (extrasByDeliveryMethod && extrasByDeliveryMethod.length === 1) {
            const extra = extrasByDeliveryMethod[0];
            if (extra.soldout) return;
            selectedExtras.push({
              ...extra,
              extra_category_id: extraGroup.id
            });
          }
        });
        if (selectedExtras.length > 0) {
          sortExtras(item, selectedExtras);
          result_item.selectedExtras = selectedExtras;
        }
      }
      return result_item;
    },
    prepareItem(item) {
      if (this.passive) {
        return;
      }
      if (item.soldout) {
        return;
      }
      if (
        item.available_sizes &&
        item.available_sizes.length >= 1 &&
        !item.selectedSize
      ) {
        this.selectedItem = item;
        this.showSelectSize = true;
        return;
      }
      item = this.preselectSingleExtras(item);

      // ACHTUNG! item.extras sind extra-groups und nicht extras!

      let nonEmptyProductExtrasByDeliveryMethod = getProductExtrasByDeliveryMethod(
        item.extras,
        this.selectedDeliveryMethod
      );

      if (
        nonEmptyProductExtrasByDeliveryMethod &&
        nonEmptyProductExtrasByDeliveryMethod.length >= 1 &&
        (typeof item.selectedExtras === "undefined" ||
          item.selectedExtras.length !==
            nonEmptyProductExtrasByDeliveryMethod.length)
      ) {
        this.selectedItem = item;
        this.showProductExtra = true;
        return;
      }

      let item_copy = productToBasketItem(createNewObject(item));
      let igs = getPopulatedIngredientGroups(item_copy);
      if (
        igs.some(ig => ig.offer_options_to_user) &&
        !item_copy.ingredientWizardDone
      ) {
        if (this.isEdit) {
          this.isEditIngredientLayer = true;
          this.selectedItem =
            item.id === this.activeItem.id ? this.activeItem : item_copy;
        } else {
          this.selectedItem = item_copy;
        }
        this.$emit("onShowIngredientWizard");
        this.showIngredientWizard = true;
        return;
      }

      this.selectedItem = {};
      this.addBasket(item);
    },
    addBasket(item) {
      this.$emit("onAddBasket", item);
    },
    checkOverflown() {
      if (this.isEdit && this.isV2EditOrder()) {
        return;
      }
      if (typeof this.$refs.productListElem === "undefined") {
        this.overflown = false;
        return;
      }
      let elem = this.$refs.productListElem;
      elem.removeEventListener("scroll", this.scroll);
      this.overflown = this.listState.rowCount > this.listState.rowsVisible;
      //TODO: Remove when at bottom Scroll position.
      if (this.overflown) {
        elem.addEventListener("scroll", this.scroll);
        this.gradient_bottom_opacity = 1.0;
        this.gradient_top_opacity = 1.0;
        setTimeout(() => {
          this.scroll(undefined);
          this.scrollBottomToTop();
        }, 0);
      }
      this.$refs.productListElem.scrollTo(0, 0);
    },
    scroll() {
      let elem = this.$refs.productListElem;
      if (!elem) return;
      let distance_from_bottom =
        elem.scrollHeight - (elem.clientHeight + elem.scrollTop);
      let bottom_multiplier =
        distance_from_bottom > 300 ? 1.0 : distance_from_bottom + 1 / 300.0;
      this.gradient_bottom_opacity = bottom_multiplier < 1 ? 0 : 1;
      let top_multiplier =
        elem.scrollTop > 300 ? 1.0 : elem.scrollTop + 1 / 300.0;
      this.gradient_top_opacity = top_multiplier < 1 ? 0 : 1;
    },
    scrollBottomToTop() {
      console.log("scrollBottomToTop");
      const TIMEOUT_BEFORE_SCROLL_START = 500;
      const SCROLL_DURATION = 1250;
      let productListElemDiv = this.$refs.productListElem;
      productListElemDiv.scrollTop = this.getScrollTo();
      setTimeout(() => {
        smoothScroll(0, SCROLL_DURATION, productListElemDiv);
      }, TIMEOUT_BEFORE_SCROLL_START);
    },
    getScrollTo() {
      let scrollTo = 0;
      let row_scroll = this.listState.rowsVisible + 2;
      if (this.listState.rowCount < row_scroll) {
        scrollTo = this.listState.rowCount * this.boxHeight;
      } else {
        scrollTo = row_scroll * this.boxHeight;
      }
      return scrollTo - this.listState.rowsVisible * this.boxHeight;
    },
    createProductList: function() {
      let productListController = this.getProductListController();
      this.positions_by_index = productListController.calculatePositionsByIndex();
      setTimeout(() => {
        let listStateResult = productListController.setRowCountAndRowsVisible();
        if (listStateResult) {
          this.listState = listStateResult;
          if (
            this.isEdit &&
            isV2EditOrder() &&
            !isEmpty(this.products_to_show)
          ) {
            // delay animation top -> down only
            this.products_to_show.forEach((product, index) => {
              this.delay.push(index * 50 + "ms");
            });
          } else {
            this.delay = productListController.setDelay();
          }
          this.checkOverflown();
        }
      }, 0);
    }
  },
  watch: {
    products_to_show() {
      this.createProductList();
    },
    computedMaxHeight() {
      setTimeout(this.checkOverflown, 0);
    }
  },
  created() {
    this.boxHeight = ProductListController.getBoxHeight();
    this.boxWidth = ProductListController.getBoxWidth();
    this.createProductList();
  }
};
</script>
<style lang="scss" scoped>
.productList.noprices > .itemBox > .itemPrice {
  opacity: 0;
  height: 5px;
}

.productList {
  width: 100%;
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  position: relative;
}

.productList-isV2EditOrder {
  overflow: unset;
}

.gradient {
  transition: opacity 0.5s ease;
  z-index: 5;
  position: absolute;
  pointer-events: none;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradient.top {
  top: -3px;
  background: var(--component_SliderTabs_top_gradient_background);
}

.gradient.bottom {
  bottom: -3px;
  background: var(--component_SliderTabs_bottom_gradient_background);
}
</style>
